export const APP_ROOT = "app-root";



// WEBPACK FOOTER //
// ./src/const.ts